module.exports = __webpack_public_path__ + "BS.png?8699015c25ec0b325b7ed18e33e72e83";